import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { ModalV2 } from 'Ui/ModalV2';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  font-family: 'font-bold';
  font-weight: 700;
  height: 9rem;
  font-size: 3rem;
  color: #000;
  padding: 1.4rem 2rem;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.6rem;
  font-family: var(--font-primary);
  padding: 2rem;

  p {
    line-height: 2rem;
    font-family: var(--font-primary);
  }
`;

const H1 = styled.h1`
  font-family: var(--font-primary);
  font-size: 2.1rem;
  font-weight: 600;
  color: #000;
  margin-bottom: 1rem;
`;

const H2 = styled.h2`
  font-family: var(--font-primary);
  font-size: 1.7rem;
  font-weight: 600;
  color: #4a4a4a;
  margin-bottom: 1rem;
`;

const P = styled.p`
  font-size: 1.3rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 2.5rem;
  margin-bottom: 2rem;

  a {
    text-decoration: underline;
  }

  .mobilierLink {
    display: block;
  }
`;

export default function BasketBarEcoResponsibleModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation('shipping', { useSuspense: false });

  return (
    <ModalV2
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
      closeIconPosition={1.5}
      noPadding
    >
      <ModalHeader>{t('ecoPartModalTitle')}</ModalHeader>
      <Body>
        <H1>{t('ecoModalTitle')}</H1>
        <P>
          {t('ecoModalFirstPara')}
          <span className="mobilierLink">{t('ecoModalSecondPara')}</span>
        </P>

        <H1>{t('ecoModalThirdPara')}</H1>
        <P>{t('ecoModalFourthPara')}</P>

        <H2>{t('ecoModalFifthPara')}</H2>
        <P>
          {t('ecoModalSixthPara')}
          <span className="mobilierLink">
            {t('ecoModalSeventhPara')}{' '}
            <a target="_blank" rel="noreferrer" href="http://www.eco-mobilier.fr/">
              http://www.eco-mobilier.fr/
            </a>
            .
          </span>
        </P>

        <P>{t('ecoModalEighthPara')}</P>

        <H1>{t('ecoModalNinthPara')}</H1>
        <P>{t('ecoModalTenthPara')}</P>

        <H2>{t('ecoModalEleventhPara')}</H2>
        <P>
          {t('ecoModalTwelfthPara')}{' '}
          <a target="_blank" rel="noreferrer" href="http://www.eco-systemes.fr/">
            http://www.eco-systemes.fr/
          </a>{' '}
          {t('ecoModalThirteenthPara')}
        </P>

        <P>{t('ecoModalFourteenthPara')}</P>
      </Body>
    </ModalV2>
  );
}
